import validate from "/app/node_modules/.pnpm/nuxt@3.15.4_@parcel+watcher@2.5.1_@types+node@22.15.17_db0@0.3.2_eslint@9.20.0_jiti@2.4_353f460422589c181bd9cda322c8637e/node_modules/nuxt/dist/pages/runtime/validate.js";
import disable_45google_45inspect_45global from "/app/middleware/disable-google-inspect.global.ts";
export const globalMiddleware = [
  validate,
  disable_45google_45inspect_45global
]
export const namedMiddleware = {}